import { render, staticRenderFns } from "./CheckboxSquare.vue?vue&type=template&id=c67ecf06&scoped=true&lang=pug&"
import script from "./CheckboxSquare.vue?vue&type=script&lang=ts&"
export * from "./CheckboxSquare.vue?vue&type=script&lang=ts&"
import style0 from "./CheckboxSquare.vue?vue&type=style&index=0&id=c67ecf06&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67ecf06",
  null
  
)

export default component.exports